export default __webpack_public_path__ + "static/media/pause_button.d83714d4.svg";